"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColor = void 0;

var getColor = function getColor(variant) {
  return variant === 'default' || variant === 'success' ? 'secondary04' : variant;
};

exports.getColor = getColor;